import { render, staticRenderFns } from "./b_table_filter_drag.vue?vue&type=template&id=74728b6a&scoped=true&"
import script from "./b_table_filter_drag.vue?vue&type=script&lang=js&"
export * from "./b_table_filter_drag.vue?vue&type=script&lang=js&"
import style0 from "./b_table_filter_drag.vue?vue&type=style&index=0&id=74728b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74728b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74728b6a')) {
      api.createRecord('74728b6a', component.options)
    } else {
      api.reload('74728b6a', component.options)
    }
    module.hot.accept("./b_table_filter_drag.vue?vue&type=template&id=74728b6a&scoped=true&", function () {
      api.rerender('74728b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/b_table_filter_drag.vue"
export default component.exports